import { Expose, Type } from 'class-transformer';

import { Customer } from '../../customers/models/customer';
import { DropdownModel } from '../../shared-features/models/dropdown-model';
import { User } from '@features/users/models/user';
import { Contract } from '@features/contracts/models/contract';
import { PricingMethod } from '@shared-features/enums/pricing-method';
import { UnitsType } from '@shared-features/enums/units-type';
import { UserInvoiceType } from '@shared-features/enums/user-invoice-type.enum';

export class Organization extends DropdownModel {
  @Expose() id: number;
  @Expose() code = '';
  @Expose({ name: 'title' }) name: string;
  @Expose() email: string;
  @Expose() contactFirstName: string;
  @Expose() contactLastName: string;
  @Expose() mobileNumber: string;
  @Type(() => Customer)
  @Expose()
  customers: Customer[];
  @Expose() customersCount: number;
  @Expose() status: string;
  @Expose() createdAt: number;
  @Expose() updatedAt: number;
  @Expose() usersCount: number;
  @Expose() pricingMethod: PricingMethod;
  @Expose() units?: UnitsType;
  @Type(() => User)
  @Expose()
  users: User[] = [];

  @Expose() contracts: Contract[];
  @Expose()
  fixedFees?: number;
  @Expose()
  organizationInvoiceType?: UserInvoiceType;
  @Expose() customerIds?: (number | "ALL")[];
 
  constructor() {
    super();
  }
  get fullContactName(): string {
    let fullName;
    if (this.contactFirstName && this.contactLastName)
      fullName = this.contactFirstName + ' ' + this.contactLastName;
    else if (this.contactFirstName) fullName = this.contactFirstName;
    else if (this.contactLastName) fullName = this.contactLastName;
    return fullName;
  }
  get dropDownDisplayName(): string {
    return this.name;
  }
  get dropDownValue(): object {
    return this;
  }
}
